import { RootState } from '../store/configureStore';

export const getPrice = (state: RootState) => state?.price?.price;

export const isFetchingPrice = (state: RootState) =>
  state?.price?.isFetchingPrice;

export const didFetchingPriceFailed = (state: RootState) =>
  state?.price?.fetchingPriceFailed;
